import React, { useRef, useState } from "react";
import "./style.scss";
import img from "../../Assets/Images/Gallery/contact.png";
import emailjs from "@emailjs/browser";
import { useTranslation } from "react-i18next";

function Contact() {
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [request, setRequest] = useState("");
  const form = useRef();

  const sendEmail = () => {
    emailjs.init("User id");
    let templateParams = {
      name: name,
      phone: phone,
      email: email,
      request: request,
    };
    console.log(templateParams);
    emailjs.send(
      "service_fwc32fb",
      "template_x81n32e",
      templateParams,
      "d4127rJrpv5jNO511"
    );
  };

  return (
    <div className="contact-page">
      <div className="contact-form">
        {/* info */}
        <div className="contact-info">
          <div className="info">
            <div className="subtitle">{t("contact.subtitle")}</div>
            <div className="title">
              <p>{t("contact.title1")}</p>
              <p>{t("contact.title2")}</p>

            </div>
            <div className="detail">
              <p>{t("contact.detail1")}</p>
              <p>{t("contact.detail2")}</p>
              <p>{t("contact.detail3")}</p>

            </div>
          </div>

          <div className="address">
            {infoAddress(t("contact.email"), "hello@ilwall.com")}
            {infoAddress(t("contact.phone"), "010 9620 8645")}
            {infoAddress(
              t("contact.visit"),
              "57, Nonhyeon-ro151-gil,\nGangnam-gu, Seoul, Korea"
            )}
          </div>
        </div>

        {/* form */}
        <form className="form">
          {infoForm(
            t("form.name"),
            t("form.nameDetail"),
            t("form.namePlaceholder"),
            setName,
            name
          )}
          {infoForm(
            t("form.email"),
            t("form.emailDetail"),
            t("form.emailPlaceholder"),
            setEmail,
            email
          )}
          {infoForm(
            t("form.phone"),
            t("form.phoneDetail"),
            t("form.phonePlaceholder"),
            setPhone,
            phone
          )}
          {infoForm(
            t("form.request"),
            t("form.requestDetail"),
            t("form.requestPlaceholder"),
            setRequest,
            request,
            true
          )}

          <div className="button-form">
            <div onClick={sendEmail} className="form-submit">
              <span>{t("form.confirm")}</span>
            </div>
          </div>
        </form>
      </div>

      <div className="contact-social">
        <div className="social-info">
          <div className="subtitle">{t("social.subtitle")}</div>
          <div className="title">
            <a href="http://google.com" className="link-social">
              Facebook
            </a>
            <a href="http://google.com" className="link-social">
              Instagram
            </a>
            <a href="http://google.com" className="link-social">
              YouTube
            </a>
            <a href="http://google.com" className="link-social">
              Behance
            </a>
          </div>
        </div>
        <div className="social-img">
          <img src={img} alt="" />
        </div>
      </div>
    </div>
  );
}

export default Contact;

const infoAddress = (title: string, detail: string) => (
  <div className="infoAddress">
    <div className="infoAddress-title">{title}</div>
    <div className="infoAddress-detail">
      <a href="https://google.com">{detail}</a>
    </div>
  </div>
);

const infoForm = (
  name: string,
  detail: string,
  placeHolder: string,
  onChange: (e: string) => void,
  value: string,
  textArea: boolean = false
) => (
  <div className="infoForm">
    <div className="name">{name}</div>
    <div className="detail">{detail}</div>

    <div style={{ height: textArea ? 200 : 60 }} className="form-input">
      {textArea ? (
        <textarea
          draggable="false"
          style={{ width: "100%" }}
          placeholder={placeHolder}
          value={value}
          onChange={(t) => onChange(t.target.value)}
        ></textarea>
      ) : (
        <input
          style={{ width: "100%" }}
          placeholder={placeHolder}
          type="text"
          value={value}
          onChange={(t) => onChange(t.target.value)}
        />
      )}
    </div>
  </div>
);
